import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  helpfulLinksTitle: {
    description: 'Title for helpful links section',
    defaultMessage: 'Helpful Links for Picking',
    id: '0gPgWA',
  },
  manageInventoryLocations: {
    description: 'Description for manage inventory information',
    defaultMessage: 'To manage inventory locations, go to Warehouses within your Inventory Management settings.',
    id: '6M/rYq',
  },
  managePickingTotes: {
    description: 'Description for managing picking totes information',
    defaultMessage: 'To manage picking totes, go to Warehouses within your Inventory Management settings.',
    id: 'xmyIrg',
  },
  addStockToInformation: {
    description: 'Add to stock information description',
    defaultMessage: 'To add stock to a location, go to Inventory settings within Product Details.',
    id: 'zzY48n',
  },
  configureInventoryLocations: {
    description: 'Message for configure inventory locations button',
    defaultMessage: 'Configure Inventory Locations',
    id: '2ALmbB',
  },
  configureTotes: {
    description: 'Message for configure totes button',
    defaultMessage: 'Configure Totes',
    id: 'gx81Hb',
  },
  viewInventory: {
    description: 'Message for view inventory button',
    defaultMessage: 'Manage Products',
    id: 'ykxE4M',
  },
});
